import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationModule } from 'src/app/authentication/authentication.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-oil-toolbar',
  templateUrl: './oil-toolbar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SharedModule, AuthenticationModule, MatButtonModule]
})
export class OilToolbarComponent {
  constructor(
    private _router: Router,
  ) { }

  addOil() {
    this._router.navigate(['vessels/oil']).then();
  }
}
